module.exports = __webpack_public_path__ + "static/media/intero_rouge.e32ff35b.svg";